import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import LargePill, {
  LargePillProps,
} from 'ext-ui/components/LargePill/LargePill'
import Pill from 'ext-ui/components/Pill/Pill'
import React from 'react'
import Box from 'src/components/Box/Box'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import { useTranslate } from 'src/localization/Trns'

import styles from './ManageSubscriptionPromoCard.style'

interface ManageSubscriptionPromoCardProps {
  className?: string
  hero?: React.ReactElement
  title: string
  pill?: string
  headerBorder?: boolean
  description: string
  disclaimer?: React.ReactNode
  largeCta?: LargePillProps
  learnMoreLink?:
    | {
        to: string
      }
    | {
        href: string
      }
  buttonCta?: {
    label: string
    onClick: () => void
    variant?: 'primary' | 'toolbar'
    'data-testid'?: string
  }
}
const ManageSubscriptionPromoCard: React.FC<
  ManageSubscriptionPromoCardProps
> = (props) => {
  const {
    className,
    hero,
    title,
    pill,
    headerBorder = false,
    description,
    disclaimer,
    largeCta,
    learnMoreLink,
    buttonCta,
  } = props
  const translate = useTranslate()

  return (
    <Box
      noShadow
      outlineBorder
      className={cn('ManageSubscriptionPromoCard', className)}
      css={styles}
    >
      <div className="flex-column justify-between h-full gap-7">
        <div className={'flex-column'}>
          {hero && <div className="hero">{hero}</div>}
          <span className={'card-title-row'}>
            <span className="card-title">{title}</span>
            {pill && (
              <Pill className={'card-title-pill'} color={'saas'}>
                {pill}
              </Pill>
            )}
          </span>
          {headerBorder && <div className="header-border" />}
          <div className="font-regular">{description}</div>
          {disclaimer && <div className="card-disclaimer">{disclaimer}</div>}
        </div>
        <div className={'flex-column gap-5'}>
          {largeCta && <LargePill {...largeCta} />}
          {(learnMoreLink || buttonCta) && (
            <div className={'w-full flex-row justify-end align-center gap-6'}>
              {learnMoreLink && (
                <HoverableLink
                  ariaLabel={translate('Learn More')}
                  {...learnMoreLink}
                >
                  {translate('Learn More')}
                </HoverableLink>
              )}
              {buttonCta && (
                <Button
                  variant={buttonCta.variant}
                  dropShadow={false}
                  onClick={buttonCta.onClick}
                  data-testid={buttonCta['data-testid']}
                >
                  {buttonCta.label}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </Box>
  )
}

export default ManageSubscriptionPromoCard
